export default {
  STATUS: {
    OPEN: 1,
    PARTIALLY_PAID: 2,
    PAID: 3,
    CANCELED: 4,
    WAIVED: 5,
    DISREGARDED: 6,
    NO_SHOW: 7,
  },
};
